import { createAction } from 'redux-act';

export const requestInitiateOutboundCall = createAction('Blender request to initiate a new outbound call');
export const requestOutboundEmail = createAction('Blender request to initiate a new outbound email');
export const requestGenericLookup = createAction('Blender request to move into generic lookup mode');
export const requestCancelOutboundCall = createAction('Blender request to close call lookup window', (workItemId, closureCode, notes) => ({ workItemId, closureCode, notes }));